import Api from "../../../services/Api";
import { ApiResponse } from "apisauce";
import { IFlashlightSearchResponse } from "../business-objects/types";
import { CountyInfo } from "../../WorkflowQueues/Keywords/business-objects/common";
import { KeywordActionTypes } from "../../WorkflowQueues/Keywords/types";

// types
export enum FlashlightSearchActionTypes {
  SEARCH = "SEARCH",
  LOAD_COUNTIES_INTO_STORE = "LOAD_COUNTIES_INTO_STORE"
}

export const DoFlashlightSearch = (url: string, request: any) => (dispatch) =>
  new Promise(function (resolve, reject) {
    dispatch(reduceResults({ results: [], message: "" }));
    Api.post(url, request)
      .then((result: ApiResponse<any>) => {
        dispatch(reduceResults(result.data));
      })
      .catch(function (ex) {
        console.log(ex);
      })
      .finally(function () {
        resolve();
      });
  });

export const reduceResults = (result: IFlashlightSearchResponse) => {
  return {
    type: FlashlightSearchActionTypes.SEARCH,
    value: result
  };
};


export const getAllCounties = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        dispatch(loadCountiesIntoStore(response.data));
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const loadCountiesIntoStore = (counties: CountyInfo[]) => {
  return {
    type: FlashlightSearchActionTypes.LOAD_COUNTIES_INTO_STORE,
    value: counties
  };
};
